import React from "react";
import SectionTitle from "../../elements/section-title/SectionTitle";

const Datas = [
  {
    id: 1,
    title: "Innovation at the Core",
    para: "We thrive on creativity and cutting-edge technology, delivering solutions that set you apart in the digital world.",
  },
  {
    id: 2,
    title: "Client-Centric Approach",
    para: "Your vision drives us. We listen, adapt, and collaborate to bring your ideas to life with precision and passion.",
  },
  {
    id: 3,
    title: "Excellence in Execution",
    para: "From concept to completion, we ensure every detail is meticulously crafted to meet your goals.",
  },
  {
    id: 4,
    title: "Trust & Transparency",
    para: "Integrity is at the heart of our partnerships. Expect clear communication and honest collaboration every step of the way.",
  },
  {
    id: 5,
    title: "Continuous Growth",
    para: "We don’t just deliver solutions—we build relationships that grow alongside your success.",
  },
];

const AboutThree = () => {
  return (
    <div className="section section-padding bg-color-dark pb--80 pb_lg--40 pb_md--20">
      <div className="container">
        <SectionTitle
          subtitle="Our Values"
          title="Why should you <span class='heading-font-italics'>work</span> with us?"
          description="Our values are the foundation of everything we do. They guide our approach, inspire our innovation, and shape the exceptional experiences we create for our clients."
          textAlignment="heading-left heading-light-left mb--100"
          textColor=""
        />

        <div className="row">
          {Datas.map((data) => (
            <div className="col-lg-4" key={data.id}>
              <div className="about-quality">
                <h3 className="sl-number">{data.id}</h3>
                <h5 className="title">{data.title}</h5>
                <p>{data.para}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ul className="list-unstyled shape-group-10">
        <li className="shape shape-1">
          <img
            src={process.env.PUBLIC_URL + "/images/others/circle-1.png"}
            alt="Circle"
          />
        </li>
        <li className="shape shape-2">
          <img
            src={process.env.PUBLIC_URL + "/images/others/line-3.png"}
            alt="Circle"
          />
        </li>
        <li className="shape shape-3">
          <img
            src={process.env.PUBLIC_URL + "/images/others/bubble-5.png"}
            alt="Circle"
          />
        </li>
      </ul>
    </div>
  );
};

export default AboutThree;
